import React from 'react';

import { Button, Col, Modal, Row } from 'react-bootstrap';
import ImageGallery from 'react-image-gallery';
import useBookingData from '../../state/booking/hooks/useProducer';
import { renderHTML } from '../../helper/encodeHtml';

export default function RoomModal({ show, handleClose, room, payment }) {
  const { booking } = useBookingData();

  const getRoomGallery = () => {
    if (Object.prototype.hasOwnProperty.call(room, 'photos')) {
      const roomPhotos = room.photos;
      if (roomPhotos.length > 0) {
        const galleryImages = roomPhotos.map((photo) => {
          const obj = {
            original: photo.replace('max500', 'max900'),
            thumbnail: photo.replace('max500', 'max100'),
          };
          return obj;
        });
        return (
          <Row className="p-1">
            <ImageGallery originalClass="image-modal" originalHeight={400} items={galleryImages} showThumbnails={false} />
          </Row>
        );
      }
    }
    return '';
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header className="bg-dark" closeButton closeVariant="white">
          <Modal.Title>{room.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark">
          <Row className="p-4">
            <Col>
              <Row>
                <h4 className="p-0 m-0 select-color">${(Math.round(room.rate_data.price_details.display_price * 100) / 100).toFixed(2)} per night</h4>
              </Row>
              <Row>
                {booking.check_in} - {booking.check_out}
              </Row>
              <Row className="text-muted">
                {booking.rooms} Room(s), {+booking.children + +booking.adults} Guest(s)
              </Row>
            </Col>
            <Col className="d-flex align-items-center justify-content-end">
              <Button className="btn-select" onClick={() => payment()}>
                Book This Room
              </Button>
            </Col>
          </Row>
          {getRoomGallery()}
          {room.rate_data.policy_data.map((policy) => {
            return (
              <Row className="p-1" key={policy.title}>
                <Col sm={12}>
                  <span className="fw-bold fs-6">{policy.title}</span>
                  {policy.paragraph_data.map((p) => (
                    <p className="text-white-50" key={Math.random()}>
                      {renderHTML(p)}
                    </p>
                  ))}
                </Col>
              </Row>
            );
          })}
        </Modal.Body>
      </Modal>
    </>
  );
}
